import { repeat } from './utils'

export const dateUtils = {
  format (date, fmt = 'YYYY-MM-DD') {
    if (!date) return date
    // 兼容safari浏览器
    if (date.replace) {
      date = date.replace(' ', 'T')
      date = date.replace(/\//g, '-')
    }
    let time = new Date(date)
    if (time.toString() === 'Invalid Date') throw Error('Invalid Date')

    let obj = {
      'Y+': time.getFullYear(),
      'M+': time.getMonth() + 1,
      'D+': time.getDate(),
      'h+': time.getHours(),
      'm+': time.getMinutes(),
      's+': time.getSeconds(),
      'q+': Math.floor((time.getMonth + 3) / 3),
      'S': time.getMilliseconds()
    }

    for (let key in obj) {
      if (new RegExp('(' + key + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? obj[key] : (repeat('0', RegExp.$1.length) + obj[key]).substr(('' + obj[key]).length))
      }
    }
    return fmt
  },

  // 是否为闰年
  isLeapYear (year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
  },

  // 后几天 | 前几天(day传负数)
  nextDates (date, day = 1, fmt) {
    if (!date) return date

    let time = new Date(date)
    if (time.toString() === 'Invalid Date') throw Error('Invalid Date')

    time = time.getTime() + day * 24 * 60 * 60 * 1000

    if (fmt) return this.format(time, fmt)

    return new Date(time)
  },

  // 后几月 | 前几月(month传负数)
  nextMonths (date, month = 1, fmt) {
    if (!date) return date

    let time = new Date(date)
    if (time.toString() === 'Invalid Date') throw Error('Invalid Date')

    // 标准日期格式使用'/'分隔，保证new Date()方法能够在更多浏览器上进行转换
    let formatDate = this.format(time, 'YYYY/MM/DD hh:mm:ss')
    let _year = time.getFullYear()
    let _month = time.getMonth() + 1

    month = _month + month

    _year = _year + Math.floor(_month / 12) + ''
    _month = month % 12 + ''
    _month = ('00' + _month).substr(_month.length)

    formatDate = formatDate.replace(/\d{4}\/\d{2}\/(.*)/, `${_year}/${_month}/$1`)

    if (fmt) return this.format(formatDate, fmt)

    return new Date(formatDate)
  }
}

export default {
  install (Vue) {
    Vue.prototype.$date = dateUtils
  }
}
